import * as classnames from 'classnames/bind';
import * as React from 'react';

const styles = require('@mintdata/mint-kit/impl/properties/components/fontIcon/FontIcon.less');
const cx = classnames.bind(styles);

export interface IFontIconProps
{
    iconName:string;
    iconSize?:14 | 16 | 20;
    className?:string;
}

export class FontIcon extends React.Component<IFontIconProps, any>
{
    public render():JSX.Element
    {
        const {iconName, iconSize = 16, className} = this.props;

        return (
            <span className={cx('icon', `icon${iconSize}`, iconName, className)} />
        );
    }
}

